import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Form, Input } from 'antd-mobile-v5'
import { WhiteSpace } from 'antd-mobile'
import { FormattedMessage, useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import { formatDate, languagesMapping, removeExpires } from '../../components/common/utils'
import { getOssSignature } from '../../reducers/oss'
import { instructorApproved } from '../../services/api'
import DetailStatus from '../../components/common/DetailStatus'
import { usePayDm } from '../../services/hooks'
import dayjs from 'dayjs'
import RequiredCerts from './RequiredCerts'
import DiverInfo from '../../components/FormTools/DiverInfo'
import Header from '../../components/FormTools/FormHeader'
import DatePickerTool from '../../components/FormTools/DatePicker'
import PickerTool from '../../components/FormTools/Picker'
import Signature from '../../components/FormTools/Signature'
import SearchInstructor from '../../components/FormTools/SearchInstructor'
import SearchStoreInfo from '../../components/FormTools/SearchStoreInfo'
import Agreement from '../../components/FormTools/Agreement'

const DMForInstructorPage = () => {
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()
  const [form] = Form.useForm()
  const [agreement, setAgreement] = useState(false)
  const {
    state: { isStore },
  } = useLocation()
  const { runAsync: toPay } = usePayDm()
  const [signature, setSignature] = useState('')
  const [instructorVerify, setInstructorVerify] = useState(false)
  const [storeVerify, setStoreVerify] = useState(false)

  const { detail, ossSignature } = useSelector((state) => ({
    detail: state.ui.instructorConfirmDetail,
    ossSignature: state.oss.ossSignature,
  }))

  useEffect(() => {
    if (detail) {
      form.setFieldsValue({
        aow: detail.aow,
        efr: detail.efr,
        efri: detail.efri,
        rescue: detail.rescue,
        aowFiles: detail.aowFiles || [],
        efrfiles: detail.efrfiles || [],
        rescueFiles: detail.rescueFiles || [],
        finishTime: new Date(detail.finishTime) || '',
        instructorNumber: detail.instructorInfoDTO ? detail.instructorInfoDTO.instructorNumber : '',
        storeNumber: detail.storeInfoDTO ? detail.storeInfoDTO.storeNumber : '',
        languageId: detail.languageId || '',
        regionId: detail.regionDTO ? detail.regionDTO.region : '',
      })
    }
    setSignature(detail.signatureUrl)
    dispatch(getOssSignature('DM'))
  }, [detail])

  const getSubmitData = () => {
    const values = form.getFieldsValue(true)
    const { storeNumber, regionId, finishTime, aowFiles, rescueFiles, efrfiles, ...data } = values
    let newData = {
      ...data,
      finishTime: formatDate(finishTime, 'YYYY-MM-DD'),
      aowFiles: removeExpires(aowFiles),
      rescueFiles: removeExpires(rescueFiles),
      efrfiles: removeExpires(efrfiles),
    }
    if (storeVerify) newData.storeNumber = storeNumber
    return newData
  }

  const editable =
    !isStore &&
    (detail.status === 'SUBMIT' || detail.status === 'ADMIN_NOT_APPROVED' || detail.status === 'WAIT_CONFIRM')

  if (!detail.userInfoDTO) return null
  return (
    <>
      <Header text={<FormattedMessage id="profile-dm" />} code={detail?.code} />
      <DiverInfo info={detail.userInfoDTO} />
      <Form form={form} validateTrigger="onSubmit">
        <Form.Header>先决条件</Form.Header>
        <RequiredCerts isInstructor={true} editable={editable} form={form} />
        <Form.Header>训练信息</Form.Header>
        {(editable || (!editable && detail.instructorInfoDTO)) && (
          <SearchInstructor
            idType={'instructor'}
            type={'NONE'}
            form={form}
            editable={editable}
            instructorVerify={instructorVerify}
            setInstructorVerify={setInstructorVerify}
            required={true}
            initInstructorInfo={detail.instructorInfoDTO}
          />
        )}
        {(editable || (!editable && detail.storeInfoDTO)) && (
          <SearchStoreInfo
            form={form}
            setStoreVerify={setStoreVerify}
            storeVerify={storeVerify}
            editable={editable}
            initStoreInfo={detail.storeInfoDTO}
          />
        )}
        <DatePickerTool
          name="finishTime"
          placeholder={formatMessage({ id: 'efri-course-date-error' })}
          disabled={!editable}
          label={formatMessage({ id: 'common-course-date' })}
          rules={[
            {
              required: true,
              message: formatMessage({ id: 'efri-course-date-error' }),
            },
          ]}
          max={dayjs().toDate()}
        />
        <Form.Header>教学地址及语言</Form.Header>
        <Form.Item name="regionId" label={formatMessage({ id: 'dm-region' })} disabled={true}>
          <Input />
        </Form.Item>
        <PickerTool
          name={'languageId'}
          form={form}
          rules={[
            {
              required: true,
              message: '语言不能为空',
            },
          ]}
          placeholder={formatMessage({ id: 'dm-lang-error' })}
          data={languagesMapping}
          label={formatMessage({ id: 'dm-lang-title' })}
          disabled={!editable}
        />
      </Form>
      <WhiteSpace />
      <Signature
        title={formatMessage({ id: 'dm-form-signature' })}
        filePath={`${detail.instructorInfoDTO.email}/${detail.instructorInfoDTO.affiliateId}`}
        modified={editable}
        oss={ossSignature}
        onSuccess={(imgUrl) => setSignature(imgUrl)}
        onClear={() => setSignature('')}
        initSignature={signature}
      />
      {editable && (
        <>
          <WhiteSpace />
          <Agreement setChecked={(val) => setAgreement(val)} checked={agreement}>
            <FormattedMessage id="dm-form-instructor-agreement" />
          </Agreement>
        </>
      )}
      <WhiteSpace />
      <DetailStatus
        form={form}
        detail={detail}
        approveFn={instructorApproved}
        getSubmitData={getSubmitData}
        payFn={toPay}
        listUrl={'/confirmApps'}
        isStore={isStore}
        agreement={agreement}
        payApplicationType={'MEMBER_APPLICATION_DM'}
        signature={signature}
      />
    </>
  )
}

export default DMForInstructorPage
